export const MOBILE_VIEWPORT = 'width=device-width, initial-scale=1.0';

export function isPhoneLike() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) {
    return true;
  }
  return navigator.maxTouchPoints > 1 && typeof window !== 'undefined' && window.screen?.width < 1024;
}

export function applyViewMode() {
  if (typeof document === 'undefined') return;
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  if (meta.getAttribute('content') === MOBILE_VIEWPORT) return;
  meta.setAttribute('content', MOBILE_VIEWPORT);
  window.dispatchEvent(new Event('resize'));
}

export function applyRouteViewMode() {
  applyViewMode();
}
